import React from "react";

const DownloadIcon = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.85286 11.7489C5.21079 12.0837 5.79207 12.0837 6.15001 11.7489L10.7316 7.46292C11.0895 7.12808 11.0895 6.5843 10.7316 6.24946C10.3736 5.91462 9.79233 5.91462 9.4344 6.24946L6.41631 9.07551V0.857191C6.41631 0.383057 6.00683 0 5.5 0C4.99317 0 4.58369 0.383057 4.58369 0.857191V9.07283L1.5656 6.25213C1.20767 5.91729 0.626383 5.91729 0.26845 6.25213C-0.0894833 6.58697 -0.0894833 7.13076 0.26845 7.4656L4.84999 11.7515L4.85286 11.7489Z"
        fill="#98A2B3"
      />
    </svg>
  );
};

export default DownloadIcon;
